import { render, staticRenderFns } from "./EliWrapperComponent.vue?vue&type=template&id=0b10cf23&"
import script from "./EliWrapperComponent.vue?vue&type=script&lang=js&"
export * from "./EliWrapperComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports